module.exports = __webpack_public_path__ + "media/success_sweepstakes/clouds-33bd55a1.png";